import { ChannelCategory } from './ChannelCategory'
import { ChannelRuleEntity } from '../../domain/entities/ChannelRule'

export type Channel = {
  uuid: string
  link: string
  title?: string
  type: ChannelType
  isPrivate: boolean
  minimalSendingInterval: number
  sendingStartTime: string
  sendingEndTime: string
  category?: ChannelCategory
  membersCount: number
  rules?: ChannelRuleEntity[]
}

export enum ChannelType {
  FREE = "FREE",
  PAID = "PAID",
  DEACTIVATED = "DEACTIVATED"
}
